<template>
    <v-card
        elevation="0"
        flat
        tile
        height="85vh"
    >
        <video
            playsinline
            preload="auto"
            muted
            autoplay
            loop
            class="hero-video"
        >
            <source
                src="../assets/video/drone_plant_footage.mp4"
                type="video/mp4"
            >
            <img
                style="width: 100%; height: 100%;"
                src="../assets/index/main-hero/Plant_2_Front_Flags1920x1080.jpg"
                alt="Front Doors of Prospira's Plant 2 Building"
                loading="lazy"
                srcset="
                    ../assets/index/main-hero/Plant_2_Front_Flags380x214.jpg 380w,
                    ../assets/index/main-hero/Plant_2_Front_Flags500x281.jpg 500w,
                    ../assets/index/main-hero/Plant_2_Front_Flags850x478.jpg 850w,
                    ../assets/index/main-hero/Plant_2_Front_Flags1920x1080.jpg 1920w,
                "
            />
        </video>

        <v-sheet class="video-overlay"></v-sheet>

        <v-container class="logo-container">
            <v-card
                flat
                tile
                color="transparent"
            >
                <v-card-title>
                    <v-img
                        src="../assets/header_logo.png"
                        width="100%"
                        max-width="500"
                        alt="Prospiras primary black and light blue logo"
                    ></v-img>
                </v-card-title>

                <v-card-subtitle class="text-sm-h4 text-md-h3 white--text mt-3">
                    Serving Society with Superior Quality
                </v-card-subtitle>
            </v-card>
        </v-container>
    </v-card>
</template>

<script>
export default {
    name: 'HeroSection',

    data() {
        return {}
    },

    computed: {
        border() {
            return this.$vuetify.breakpoint.mdAndDown ? '' : 'hero-text';
        }
    }
}
</script>

<style scoped>
.hero-video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
}

.logo-container {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 auto;
    transform: translateX(-50%) translateY(-50%) !important;
}

.video-overlay {
    background-color: white;
    position: absolute;
    margin: 0 auto;
    top: 0;
    left: 0;
    opacity: .1;
    width: 100%;
    height: 85vh;
}
</style>